import { ReactNode } from 'react';
import { Typography } from 'antd';

import EllipsisText from 'components/EllipsisText';

import CopyIcon from 'resources/svg/copy_icon.svg';

import { shortenAddress } from 'utils';

const { Paragraph } = Typography;

type AddressCopyProps = {
  address: string;
  isVisibleCopy?: boolean;
  isShorten?: boolean;
  subAddress?: ReactNode;
  customAddress?: string;
  totalPrefixNumber?: number;
};

const AppAddress = ({
  address,
  isVisibleCopy = true,
  isShorten = true,
  subAddress,
  customAddress,
  totalPrefixNumber,
}: AddressCopyProps) => {
  const renderAddress = customAddress ? customAddress : address;
  return (
    <div className="app-address">
      <div>
        <EllipsisText text={isShorten ? shortenAddress(renderAddress, -4, totalPrefixNumber) : renderAddress} />
        {subAddress && <EllipsisText text={subAddress} />}
      </div>
      {isVisibleCopy && (
        <Paragraph
          copyable={{
            text: address,
            icon: <img className="app-address__icon" src={CopyIcon} key="copy-icon" />,
          }}
        />
      )}
    </div>
  );
};

export default AppAddress;
